// extracted by mini-css-extract-plugin
export default {"main":"GenericGreyButton_main__q08aO"};